import { render } from "./TaskInfo.vue?vue&type=template&id=6a559d94&scoped=true"
import script from "./TaskInfo.vue?vue&type=script&lang=js"
export * from "./TaskInfo.vue?vue&type=script&lang=js"

import "./TaskInfo.vue?vue&type=style&index=0&id=6a559d94&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a559d94"]])

export default __exports__